<template>
<div class="cart-container container">
    <div class="row">
        <form role="form">
            <div class="form-group">
                <label>Order Type: </label>
                <select class="form-control">
                    <option value="pickup">Pickup</option>
                    <option value="delivery">Delivery</option>
                </select>
            </div>
            <div class="form-group">
                <label>Select a box type: </label>
                <select class="form-control" v-model="selectedPackage">
                    <option v-for="box in packages" v-bind:key="box.title" v-bind:value="box.title" >{{box.title}}</option>
                </select>
                <button type="button" class="btn-primary" v-on:click="addItem">Add to Order</button>
            </div>
             <div class="form-group">
                
                <table class="table">
                    <thead>
                        <tr>
                            <td>Package</td>
                            <td>Flavor Count</td>
                            <td>Cost</td>
                            <td>Qty</td>
                            <td>Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="box in order" v-bind:key="box.title">
                            <td>
                               <div> {{box.title}}</div>
                               
                                       
                                                <div>
                                                    <div v-for="flavor of flavors" :key="flavor.id">
                                                        <input v-bind:id="flavor.id" type="checkbox" v-bind:value="flavor.id">
                                                        <label class="flavor-radio" v-bind:for="flavor.id">{{flavor.primary.flavor_title[0].text}}</label>
                                                    </div>
                                                </div>
                                       
                            </td>
                             <td>
                                 <select v-model="box.flavorCount">
                                     <option v-for="option in packageOptions(box.title)" v-bind:key="option.flavors" v-bind:value="option.flavors">{{option.flavors }} {{option.flavors == 1 ? " flavor": " flavors"}}</option>
                                 </select>
                             </td>
                             <td>
                                 ${{packageCost(box)}}
                             </td>
                            <td><input type="number" v-model="box.qty"></td>
                            <td>
                               ${{box.subTotal()}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</div>
</template>
<script>
import $ from "jquery"

class Order {
    title;
    flavorCount;
    cost = 0;
    qty = 0;
    subTotal(){
        return parseInt(this.cost) * parseInt(this.qty);
    };

}

export default {
    name: "Cart",
    data() {
        return {
            flavors: null,
            packages: [{title: "24 Count Box", options: [{flavors: 1, cost: 32},{flavors: 6, cost: 36}]},
                        {title: "12 Count Box", options: [{flavors: 1, cost: 16},{flavors: 3, cost: 19}]},
                        {title: "4 Count Box", options: [{flavors: 1, cost: 6},{flavors: 2, cost: 9}]}
                    ],
            order: [],
            selectedPackage: ""
        }
    },
    computed: {
       
    },
    methods: {
        getFlavorContent (uid) {
            this.$prismic.client.getByUID('flavors', uid)
            .then((document) => {
                if (document) {
                console.log(document.data);
                this.flavors = document.data.body
                } else {
                this.$router.push({ name: 'not-found' })
                }
            })
        },
        getPackageContent (uid){
            this.$prismic.client.getByUID('alt-sections',uid)
            .then((document => {
                if(document){
                    this.packages = document.data.body
                }
            }))
        },
        addItem (event) {
          //  console.log(this.selectedPackage);
            var item = this.packages.filter(x => {
                return x.title == this.selectedPackage;
            });
            var oItem = new Order();
            oItem.title = item[0].title;
            this.order.push(oItem);
            
           // console.log(this.order);
        },
         packageOptions: function(opt) {      
            return this.packages.filter(x => {
                return x.title == opt;
            })[0].options;
        },
        packageCost: function(t){
            console.log(t);
            if (t.flavorCount){
                  return this.packages.filter(x => {
                    return x.title == t.title
                })[0].options.filter(y => {
                    return y.flavors == t.flavorCount;
                })[0].cost;
            }
            else {
                return;
            }
          
        }
    },
    created () {
        this.getFlavorContent('flavor-page');
      //  this.getPackageContent('packages');
      
    }
}
</script>
<style lang="scss">
.cart-container {
    margin-top: 100px;
    .flavor-radio {
        margin-left: 8px;
    }
}
</style>